import api from '../../api/client';
// src/pages/AnimalCyclePage.jsx
import React, { useEffect, useMemo, useState } from "react";
import AnimalCyclePage from "./AnimalCycleCategory";

export default function GoatsCyclePage() {
  return (
    <>
      <AnimalCyclePage species="goats" />
    </>
  );
}
